// extracted by mini-css-extract-plugin
module.exports = {"overview":"Item_overview__hHbwW","running":"Item_running__3TEcd","sleep":"Item_sleep__2W2ya","gym":"Item_gym__2AXra","name":"Item_name__3hHb0","link":"Item_link__1ZKgg"};